// extracted by mini-css-extract-plugin
export default {"label":"TextAreaLabel_label__vH8J9","required":"TextAreaLabel_required__lEcO6","optional":"TextAreaLabel_optional__6nb1t"};